/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, useCallback, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as _ from "lodash";
import ImageViewer from "react-simple-image-viewer";
import { Skeleton } from "react-skeleton-generator";
import UserContext from "../../context/UserContext";
import CarrouselProducts from "../../components/store/CarrouselProducts";
import { shopifyService } from "../../services/api/shopify";
import { cartServices } from "../../services/api/cart";
import { notifications } from "../../utils/notifications";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { validationPrice } from "../../utils";
import ProductImages from "../../components/store/ProductImages";
import { Swiper, SwiperSlide } from "swiper/react";

const ProductSingleView = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { currentUser } = useContext(UserContext);

  const [itMayInterestYou, setItMayInterestYou] = useState([]);
  const [product, setProduct] = useState({});
  const [variantOption1, setVariantOption1] = useState({});
  const [variantOption2, setVariantOption2] = useState({});
  const [variantOption3, setVariantOption3] = useState({});
  const [variant, setVariant] = useState({});
  const [variantImage, setVariantImage] = useState({});
  const [variantOptionsSelected, setVariantOptionsSelected] = useState({
    option1: "",
    option2: "",
    option3: "",
  });

  const [productStock, setProductStock] = useState(0);
  const [selectedQuantity, setSelectedQuantity] = useState(1);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [isLoaded, setIsLoaded] = useState(false);

  const [currentPrice, setCurrentPrice] = useState();
  const [currentPrices, setCurrentPrices] = useState({
    price: null,
    compare_at_price: null,
  });

  const handleShoppingCart = async (
    id,
    quantity,
    variants,
    shopify_store_id,
    goToCart
  ) => {
    if (quantity === 0) {
      quantity = 1;
    }

    let variantId = variants[0].id;
    if (variants.length > 1) {
      variants.forEach((variant) => {
        let name = variantOptionsSelected.option1;
        if (
          variantOptionsSelected.option2 !== null &&
          variantOptionsSelected.option2 !== ""
        ) {
          name = name + " / " + variantOptionsSelected.option2;
        }
        if (
          variantOptionsSelected.option3 !== null &&
          variantOptionsSelected.option3 !== ""
        ) {
          name = name + " / " + variantOptionsSelected.option3;
        }

        if (variant.title === name) {
          variantId = variant.id;
        }
      });
    }

    await cartServices
      .addProductToCart({
        product_id: id,
        amount: quantity,
        variant_id: variantId,
        shopify_store_id: shopify_store_id,
      })
      .then((response) => {
        notifications.success(response.data.message);
        if (goToCart) {
          navigate("/carrito-de-compras");
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          notifications.warn(
            <div>
              {" "}
              <a
                onClick={() =>
                  navigate({ pathname: "", search: "?login=true" })
                }
                className="text-primary-200"
              >
                Inicie sesión{" "}
              </a>
              para adquirir un producto
            </div>
          );
        }
      });
  };

  const fetchProducts = () => {
    shopifyService
      .getAllProducts()
      .then((response) => {
        let products = response.data.products;
        setItMayInterestYou(products.slice(10, 15));
      })
      .catch((err) => {});
  };

  const fetchProductById = () => {
    shopifyService
      .getProduct(parseInt(params.id), parseInt(params.store_id))
      .then((response) => {
        let product = response.data.product;
        setVariantImage({});
        setProduct(product);
        setCurrentPrice(
          showPrice()
            ? product.variants[0].price
            : product.variants[0].compare_at_price > 0
            ? product.variants[0].compare_at_price
            : product.variants[0].price
        );
        setCurrentPrices({
          price: product.variants[0].price,
          compare_at_price: product.variants[0].compare_at_price,
        });
        if (product.options[0]) {
          setVariantOption1(product.options[0]);
          setVariantOptionsSelected((state) => ({
            ...state,
            option1: product.options[0].values[0],
          }));
        }
        if (product.options[1]) {
          setVariantOption2(product.options[1]);
          setVariantOptionsSelected((state) => ({
            ...state,
            option2: product.options[1].values[0],
          }));
        }
        if (product.options[2]) {
          setVariantOption3(product.options[2]);
          setVariantOptionsSelected((state) => ({
            ...state,
            option3: product.options[2].values[0],
          }));
        }
      })
      .catch((err) => {
        err.response.status === 404 && navigate("producto-no-encontrado");
        err.response.status === 400 && navigate("/tienda");
      });
  };

  const changeVariant = (variantSelected) => {
    if (product.variants.length > 1) {
      product.variants.forEach((variant) => {
        let name = variantOptionsSelected.option1;
        if (
          variantOptionsSelected.option2 !== null &&
          variantOptionsSelected.option2 !== ""
        ) {
          name = name + " / " + variantOptionsSelected.option2;
        }
        if (
          variantOptionsSelected.option3 !== null &&
          variantOptionsSelected.option3 !== ""
        ) {
          name = name + " / " + variantOptionsSelected.option3;
        }
        if (variantSelected === variant.title) {
          setCurrentPrice(
            showPrice()
              ? variant.price
              : variant.compare_at_price > 0
              ? variant.compare_at_price
              : variant.price
          );
          setCurrentPrices({
            price: variant.price,
            compare_at_price: variant.compare_at_price,
          });
        }
      });
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    fetchProductById();
  }, [params.id]);

  useEffect(() => {
    if (!currentUser) return;
    let finalPrice = showPrice()
      ? currentPrices.price
      : currentPrices.compare_at_price > 0
      ? currentPrices.compare_at_price
      : currentPrices.price;
    setCurrentPrice(finalPrice);
  }, [currentUser, currentPrices]);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const setQuantityOptions = () => {
    let limit = productStock;
    let options = [];
    for (let index = 0; index < limit; index++) {
      options.push(
        <option key={index} value={index + 1}>
          {index + 1}
        </option>
      );
    }
    return options;
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const getStock = () => {
    let variant = null;

    let opt1 =
      variantOptionsSelected.option1 !== ""
        ? variantOptionsSelected.option1
        : null;
    let opt2 =
      variantOptionsSelected.option2 !== ""
        ? variantOptionsSelected.option2
        : null;
    let opt3 =
      variantOptionsSelected.option3 !== ""
        ? variantOptionsSelected.option3
        : null;

    // BY DEFAULT RETURN SUM OF ALL STOCK VARIANTS BY DEFAULT RETURN SUM OF ALL STOCK VARIANTS
    if (
      Object.values(variantOptionsSelected).every((option) => option === "")
    ) {
      let stocks = product.variants.map(
        (variant) => variant.inventory_quantity
      );
      return stocks.reduce(function (previousValue, currentValue) {
        return previousValue + currentValue;
      });
    }

    // IF VARIANT IS MATCH, RETURN ITS STOCK
    product.variants.forEach((_variant) => {
      if (
        _variant.option1 === opt1 &&
        _variant.option2 === opt2 &&
        _variant.option3 === opt3
      ) {
        variant = _variant;
        return true;
      }
    });

    if (!variant) return 0;

    setVariant(variant);

    return variant.inventory_quantity;
  };

  const getImage = () => {
    let imageMatch = null;

    if (
      product.variants.length === 1 &&
      product.variants[0].title === "Default Title" &&
      product.image &&
      product.image.src
    )
      return product.image.src;

    product.images.forEach((image) => {
      if (image.variant_ids.includes(variant.id)) {
        imageMatch = image;
        return true;
      }
    });

    setVariantImage(imageMatch);
  };

  const showPrice = () => {
    return validationPrice(currentUser, product.vendor);
  };

  useEffect(() => {
    if (_.isEmpty(product)) return;
    setProductStock(getStock());
  }, [variantOptionsSelected, product]);

  useEffect(() => {
    if (productStock < 1) setSelectedQuantity(0);
  }, [productStock]);

  useEffect(() => {
    if (_.isEmpty(variant)) return;
    getImage();
  }, [variant]);

  useEffect(() => {
    let vars = [product];
    if (vars.every((element) => !_.isEmpty(element))) {
      setIsLoaded(true);
    }
  }, [itMayInterestYou, product]);

  useEffect(() => {
    if (product && product.variants) {
      setCurrentPrices({
        price: product.variants[0].price,
        compare_at_price: product.variants[0].compare_at_price,
      });
      setCurrentPrice(
        showPrice()
          ? product.variants[0].price
          : product.variants[0].compare_at_price > 0
          ? product.variants[0].compare_at_price
          : product.variants[0].price
      );
    }
  }, [product]);

  useEffect(() => {
    if (isViewerOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.pointerEvents = "none";
    } else {
      setTimeout(() => {
        document.body.style.overflow = "auto";
        document.body.style.pointerEvents = "auto";
      }, 500);
    }
  }, [isViewerOpen]);

  return (
    <div className="">
      {/* PRODUCT */}
      <div className="w-full md:px-4">
        <div className="container mx-auto w-full lg:pt-12">
          {isLoaded ? (
            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-5">
              {/* IMAGES COL */}
              <div>
                <ProductImages
                  images={product.images}
                  variantImage={variantImage}
                />
              </div>

              {/* INFO */}
              <div className="mx-0 lg:mx-5 px-4">
                <p className="text-sm text-gray-new font-bold text-center">
                  {productStock < 1
                    ? "No disponible"
                    : `Disponible en: ${product && product.vendor}`}
                </p>

                {!product.isMostSold && (
                  <div className="flex justify-center">
                    <div className="bg-secondary-new-50 rounded-xl lg:rounded-3xl w-40 uppercase my-2 text-xs text-secondary-new font-bold px-3 py-1 lg:py-2 text-center">
                      Más vendido
                    </div>
                  </div>
                )}
                <p className="text-center md:mt-2 text-2xl lg:text-[33px] font-bold text-gray-new">
                  {product.title}
                </p>

                {/* PRICES */}
                <p
                  className={`text-center font-bold text-xl lg:text-[25px] text-gray-new ${
                    true ? "mt-5" : ""
                  }`}
                >
                  ${currentPrice} mxn
                </p>

                {!showPrice() && currentPrices.compare_at_price > 0 && (
                  <div className="flex flex-col items-center">
                    <a
                      href="/membresias"
                      className="text-center font-bold text-[28px] lg:text-[30px] text-secondary-new"
                    >
                      ${currentPrices.price} mxn
                    </a>

                    <div className="bg-secondary-new-50 rounded-xl lg:rounded-3xl w-40 uppercase my-2 text-xs text-secondary-new font-bold px-3 py-1 lg:py-2 text-center">
                      PRECIO MIEMBROS
                    </div>
                  </div>
                )}

                {/* IMAGES SLIDER */}
                <div className="block overflow-x-auto h-20 mt-8 w-full max-w-[300px] mx-auto">
                  <div className="flex justify-center space-x-1 w-full">
                    {product.images.map((image, index) => (
                      <img
                        key={index}
                        src={image.src}
                        alt=""
                        className="cursor-pointer h-16 w-16 object-contain"
                        onClick={() => openImageViewer(index)}
                      />
                    ))}
                  </div>
                </div>

                {/* VARIANTS */}
                {product.options[0].values.length > 1 && (
                  <div className="text-center space-y-5 mt-10">
                    {!_.isEmpty(variantOption1) && (
                      <div>
                        <p className="text-sm lg:text-2xl text-gray-new font-bold mb-1">
                          {variantOption1.name}
                        </p>
                        <select
                          name="variant-option-1"
                          value={variantOptionsSelected.option1}
                          className="w-1/2 bg-white text-gray-new text-sm lg:text-xl border border-slate-300 py-2 px-3 focus:outline-none rounded-xl"
                          onChange={(event) => {
                            setVariantOptionsSelected((state) => ({
                              ...state,
                              option1: event.target.value,
                            }));
                            changeVariant(event.target.value);
                          }}
                        >
                          {variantOption1.values.map((option, idx) => (
                            <option
                              key={`${variantOption1.name}-opt-${idx}`}
                              value={option}
                            >
                              {capitalizeFirstLetter(option)}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    {!_.isEmpty(variantOption2) && (
                      <div>
                        <p className="text-sm lg:text-2xl text-gray-new font-bold mb-1">
                          {variantOption2.name}
                        </p>
                        <select
                          name="variant-option-2"
                          value={variantOptionsSelected.option2}
                          className="w-1/2 bg-white text-gray-new text-sm lg:text-xl border border-slate-300 py-2 px-3 focus:outline-none rounded-xl"
                          onChange={(event) => {
                            setVariantOptionsSelected((state) => ({
                              ...state,
                              option2: event.target.value,
                            }));
                            changeVariant(event.target.value);
                          }}
                        >
                          {variantOption2.values.map((option, idx) => (
                            <option
                              key={`${variantOption2.name}-opt-${idx}`}
                              value={option}
                            >
                              {capitalizeFirstLetter(option)}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    {!_.isEmpty(variantOption3) && (
                      <div>
                        <p className="text-sm lg:text-2xl text-gray-new font-bold mb-1">
                          {variantOption3.name}
                        </p>
                        <select
                          name="variant-option-3"
                          value={variantOptionsSelected.option3}
                          className="w-1/2 bg-white text-gray-new text-sm lg:text-xl border border-slate-300 py-2 px-3 focus:outline-none rounded-xl"
                          onChange={(event) => {
                            setVariantOptionsSelected((state) => ({
                              ...state,
                              option3: event.target.value,
                            }));
                            changeVariant(event.target.value);
                          }}
                        >
                          {variantOption3.values.map((option, idx) => (
                            <option
                              key={`${variantOption3.name}-opt-${idx}`}
                              value={option}
                            >
                              {capitalizeFirstLetter(option)}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                )}

                {/* QUANTITY */}
                <div
                  className={`w-auto flex flex-col items-center ${
                    product.options[0].values.length === 0 ? "mt-10" : "mt-5"
                  }`}
                >
                  <div className="flex items-center space-x-2 mb-1">
                    <p className="text-center lg:text-left text-sm lg:text-2xl text-gray-new font-bold">
                      Cantidad
                    </p>
                    <div
                      className={`rounded-xl lg:rounded-3xl w-28 uppercase text-xs font-bold px-1 py-1 lg:py-2 text-center ${
                        productStock < 1
                          ? "bg-[#FFCCCC] text-[#D32F2F]"
                          : "bg-[#C8E6C9] text-[#388E3C]"
                      }`}
                    >
                      {productStock < 1
                        ? "Sin existencia"
                        : `En stock: ${productStock}`}
                    </div>
                  </div>

                  <select
                    name="quantity"
                    value={selectedQuantity}
                    className="w-1/2 bg-white text-gray-new text-sm lg:text-xl border border-slate-300 py-2 px-3 focus:outline-none rounded-xl"
                    disabled={productStock === 0}
                    onChange={(event) =>
                      setSelectedQuantity(event.target.value)
                    }
                  >
                    <option value={0} disabled>
                      Seleccionar
                    </option>
                    {setQuantityOptions()}
                  </select>
                </div>

                <div className="md:col-span-4 xl:col-span-3">
                  {/* BUTTONS */}
                  <div className="w-3/4 lg:w-1/2 h-autom mx-auto mt-8 space-y-5">
                    <button
                      onClick={() =>
                        handleShoppingCart(
                          product.id,
                          selectedQuantity,
                          product.variants,
                          product.shopify_store_id,
                          false
                        )
                      }
                      className="w-full transition-all duration-200 ease-in bg-white hover:bg-[#fffbf0] rounded-full border border-secondary-new text-white text-center font-bold py-3 text-lg disabled:opacity-75 disabled:cursor-not-allowed"
                      disabled={productStock < 1}
                    >
                      <div className="flex items-center justify-center">
                        <p className="text-base font-bold text-secondary-new">
                          Agregar al carrito
                        </p>
                      </div>
                    </button>

                    <button
                      onClick={() =>
                        handleShoppingCart(
                          product.id,
                          selectedQuantity,
                          product.variants,
                          product.shopify_store_id,
                          true
                        )
                      }
                      className="w-full transition-all duration-300 ease-in bg-secondary-new hover:bg-[#F5A800] rounded-full border border-secondary-new text-white text-center font-bold py-3 text-lg disabled:opacity-75 disabled:cursor-not-allowed"
                      disabled={productStock < 1}
                    >
                      <div className="flex items-center justify-center">
                        <p className="text-base font-bold text-white">
                          Comprar ahora
                        </p>
                      </div>
                    </button>
                  </div>

                  <hr className="border border-[#E2E2E2] mt-10 mb-5" />

                  <div className="pb-5">
                    <p className="text-lg text-gray-new font-bold">
                      Descripción
                    </p>
                    <div
                      className="prose prose-sm lg:prose-base text-gray-new-100"
                      dangerouslySetInnerHTML={{ __html: product.body_html }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            heroSkeleton()
          )}
        </div>
      </div>

      {/* YOU MAY ALSO LIKE */}
      <div className="w-full px-4">
        {isLoaded ? (
          itMayInterestYou.length > 0 && (
            <div className="container mx-auto w-full pt-6 md:pt-12">
              <div className="pb-12 md:pb-16">
                <p className="text-primary-new text-left text-2xl lg:text-4xl font-bold pb-8">
                  También podría interesarte
                </p>

                <CarrouselProducts
                  products={itMayInterestYou}
                  productsSkeleton={() => productsSkeleton("theMostSold")}
                />
              </div>
            </div>
          )
        ) : (
          <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-5">
            {productsSkeleton()}
          </div>
        )}
      </div>

      {isViewerOpen && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              zIndex: 49,
              pointerEvents: "none",
            }}
          />

          {/* Carrusel */}
          <div style={{ pointerEvents: "auto" }}>
            <Swiper
              slidesPerView={1}
              spaceBetween={5}
              pagination={{
                dynamicBullets: true,
                clickable: false,
              }}
              loop
              longSwipes={true}
              initialSlide={currentImage}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 50,
              }}
              onClick={() => setIsViewerOpen(false)}
            >
              {product.images.map((image) => (
                <SwiperSlide key={image.id}>
                  <div className="flex justify-center items-center w-full h-full p-4">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="m-0 cursor-pointer max-w-full max-h-full object-contain"
                      onClick={() => null}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </>
      )}
    </div>
  );
};

const heroSkeleton = () => {
  return (
    <Skeleton.SkeletonThemeProvider animation="opacity">
      <div className="w-full h-96">
        <Skeleton height="100%" borderRadius="0px" />
      </div>
    </Skeleton.SkeletonThemeProvider>
  );
};

const productsSkeleton = (section) => {
  return [...Array(5)].map((e, idx) => (
    <Skeleton.SkeletonThemeProvider key={idx} animation="opacity">
      <div key={`${section}-${idx}`} className="h-72">
        <Skeleton height="100%" borderRadius="0px" />
      </div>
    </Skeleton.SkeletonThemeProvider>
  ));
};

export default ProductSingleView;
